import { RootState } from "@base/store";
import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import {
  Avatar,
  ProfileWrapper,
  UserInfoContainer,
} from "../../profile.styled";
import { UserFullName, UserName } from "./profileToggle.styled";

const ProfileToggle = () => {
  const user = useSelector((state: RootState) => state.user.user);

  const stringAvatar = (name: string) => {
    return {
      children: `${name?.split(" ")[0][0]?.toUpperCase()}${name
        ?.split(" ")[1][0]
        ?.toUpperCase()}`,
    };
  };

  const displayName = () => {
    let name = "";
    if (user?.firstName) {
      name = user?.firstName;
    }
    if (user?.lastName) {
      name = user?.lastName;
    }
    if (user?.firstName && user?.lastName) {
      name = `${user?.firstName} ${user?.lastName}`;
    }
    return name;
  };

  return (
    <UserInfoContainer>
      <ProfileWrapper>
        <div>
          {user?.profileImg ? (
            <Avatar alt="user Photo" src={user?.profileImg} />
          ) : (
            <Avatar
              alt="user Photo"
              {...stringAvatar(`${user?.firstName} ${user?.lastName}`)}
            />
          )}
        </div>
        <UserFullName>{displayName()}</UserFullName>
      </ProfileWrapper>
    </UserInfoContainer>
  );
};

export default ProfileToggle;
